import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import image from '../../images/process-1.webp';
import image2 from '../../images/process-2.webp';
import image3 from '../../images/process-3.webp';
import image4 from '../../images/process-4.webp';
import { styled } from '@mui/system';

const GradientText = styled(Typography)({
  background: 'linear-gradient(90deg, rgba(255,0,150,1) 0%, rgba(0,204,255,1) 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
});

const DevelopmentProcess = () => {
  return (
    <Box sx={{ padding: '40px', textAlign: 'center' }}>
      <GradientText variant="overline" sx={{ color: 'magenta', fontWeight: 'bold', mb: 2, fontSize: '15px' }}>
        Process
      </GradientText>
      <Typography variant="h3" fontSize={'40px'} sx={{ fontWeight: 'bold', marginBottom: '16px',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
        Our Development Process
      </Typography>
      <Typography variant="subtitle1" sx={{ color: 'grey', marginBottom: '40px', textAlign: 'center',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
        Our design process follows a proven approach. We begin with a deep understanding of your needs and create a planning template.
      </Typography>

      <Grid container spacing={4} justifyContent="center" alignItems="center">
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: 'center', padding: '16px' }}>
            <img
              src={image}
              alt="Requirement Gathering"
              style={{
                width: '100%',
                maxWidth: { xs: '200px', md: '350px' },
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(10,0,0,0.3)',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ textAlign: 'left', padding: '16px' }}>
            <Box
              sx={{
                backgroundColor: '#F7F7F7',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                marginLeft: '0px',
                border: '4px solid rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>1</Typography>
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: '8px', fontSize: '35px',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              Requirement Gathering
            </Typography>
            <Typography variant="body1" sx={{ color: 'grey',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              During "Requirement Gathering," we thoroughly understand your needs and objectives to lay the foundation for a tailored and successful project.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={4} justifyContent="center" alignItems="center" mt={2}>
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: 'center', padding: '16px' }}>
            <img
              src={image2}
              alt="Prototype"
              style={{
                width: '100%',
                maxWidth: { xs: '200px', md: '350px' },
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(10,0,0,0.3)',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ textAlign: 'left', padding: '16px' }}>
            <Box
              sx={{
                backgroundColor: '#F7F7F7',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                marginLeft: '0px',
                border: '4px solid rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>2</Typography>
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: '8px', fontSize: '35px',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              Prototype
            </Typography>
            <Typography variant="body1" sx={{ color: 'grey',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              In the "Prototype" phase, we create a working model of your project to visualize its functionality and design before moving to full development.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={4} justifyContent="center" alignItems="center">
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: 'center', padding: '16px' }}>
            <img
              src={image3}
              alt="Develop & Deployment"
              style={{
                width: '100%',
                maxWidth: { xs: '200px', md: '350px' },
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(10,0,0,0.3)',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ textAlign: 'left', padding: '16px' }}>
            <Box
              sx={{
                backgroundColor: '#F7F7F7',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                marginLeft: '0px',
                border: '4px solid rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>3</Typography>
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: '8px', fontSize: '35px',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              Develop & Deployment
            </Typography>
            <Typography variant="body1" sx={{ color: 'grey',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              In the "Develop & Deployment" phase, we build and launch your project, ensuring a smooth transition from development to the live environment.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={4} justifyContent="center" alignItems="center" mt={2}>
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: 'center', padding: '16px' }}>
            <img
              src={image4}
              alt="Support & Maintenance"
              style={{
                width: '100%',
                maxWidth: { xs: '200px', md: '350px' },
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(10,0,0,0.3)',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ textAlign: 'left', padding: '16px' }}>
            <Box
              sx={{
                backgroundColor: '#F7F7F7',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                marginLeft: '0px',
                border: '4px solid rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>4</Typography>
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: '8px', fontSize: '35px',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              Support & Maintenance
            </Typography>
            <Typography variant="body1" sx={{ color: 'grey',fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              In the "Support & Maintenance" phase, we provide ongoing assistance and updates to ensure your project remains secure and optimized for peak performance.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DevelopmentProcess;
